import lrsAdapter from '../../helpers/lrs_adapter'
import getAxiosInstance from '../../helpers/get_axios_instance'

class Cargador {
  static getCuitMapeoByUsername (username) {
    const axios = getAxiosInstance()
    const promise = axios.get(`mapeo_cargador?r=` +
      `{"clave":{"usuario": "${username}"}}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => result.data[0])
  }
}

export default Cargador
